import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/accessibility/fr/accessibility_FR.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Accessibility/accessibility__fr-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['fr-FR'].layout },
  seo: {
    title: "Notre engagement en matière d'accessibilité | Assurance Lemonade",
    metaTitle: "Notre engagement en matière d'accessibilité | Assurance Lemonade",
    description:
      "Lemonade s'engage à rendre le contenu de son site internet accessible et facile d'accès pour tous. Nous prenons vos suggestions au sérieux afin de satisfaire l'ensemble de nos clients.",
    ogImage: og.src,
  },
  MDXContent: content as DocumentTypes,
};
